import {
  Directive,
  forwardRef,
  Input
} from '@angular/core';
import { NG_VALIDATORS
} from '@angular/forms';
import type { Provider,
  Type
} from '@angular/core';
import type {
  AbstractControl,
  ValidationErrors,
  Validator
} from '@angular/forms';

export const INPUT_VALIDATOR: Provider = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef((): Type<InputValidator> => InputValidator),
  multi: true
};

export type ValueValidator = (value: unknown) => ValidationErrors | null;

@Directive({
  selector: '[tdWbInputValidator][ngModel]',
  providers: [INPUT_VALIDATOR]
})
export class InputValidator implements Validator {
  // neutral validator so validate() is safe before a consumer sets one
  private _inputValidatorFn: ValueValidator = () => null;
  private onChange?: () => void;

  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input('tdWbInputValidator')
  set inputValidator(value: ValueValidator) {
    this._inputValidatorFn = value ;
    if (this.onChange !== undefined) {
      this.onChange();
    }
  }

  validate(c: AbstractControl): ValidationErrors | null {
    return this._inputValidatorFn !== undefined && c.value !== undefined && c.value !== null ? this._inputValidatorFn(c.value) : null;
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onChange = fn;
  }
}
